import React from "react"
import { useStyles } from "@/pages/campaign-form/components/sections/message/MessageVariationSection/MessageVariationSection.styles"
import { useFormContext } from "react-hook-form"
import { CampaignFormValues } from "@/pages/campaign-form/types"
import { getMessageFieldName } from "@/pages/campaign-form/components/campaigns/writeALetter/Message.helper"
import { Icon } from "@/components"

const { MessageVariationsType, MessageVariationGenerationAiType } = DjangIO.app.grassroots.campaign.types

export const BadgesSection = ({ messageIndex, currentMessageIndex, prefix }) => {
    const { classes } = useStyles()
    const formContext = useFormContext<CampaignFormValues>()

    const currentMessage = formContext.watch(getMessageFieldName(messageIndex, "message_variations", prefix))[
        currentMessageIndex - 1
    ]

    const showBadges = () =>
        formContext.watch(getMessageFieldName(messageIndex, "message_variations_type", prefix)) ===
        MessageVariationsType.auto_generated.value

    const showAiBadge = () =>
        showBadges() &&
        currentMessage.ai_generation_type === MessageVariationGenerationAiType.ai_generated.value &&
        currentMessageIndex > 1

    const showEditedBadge = () =>
        showBadges() &&
        currentMessage.ai_generation_type === MessageVariationGenerationAiType.ai_generated_and_edited.value &&
        currentMessageIndex > 1

    const showOriginalDraftBadge = () => showBadges() && currentMessageIndex === 1

    return (
        <>
            {showOriginalDraftBadge() && <div className={classes.badgeOriginalEdited}>Original Draft</div>}
            {showAiBadge() && (
                <div className={classes.badgeAuto}>
                    <Icon size="sm" icon="sparkles" iconFamily="fas" aria-hidden="true" />
                    AI Enhanced
                </div>
            )}
            {showEditedBadge() && (
                <div className={classes.aiBadgesWrapper}>
                    <div className={classes.badgeOriginalEdited}>
                        <Icon size="sm" icon="pencil" iconFamily="fas" aria-hidden="true" />
                        Edited
                    </div>
                    <div className={classes.badgeAuto}>
                        <Icon size="sm" icon="sparkles" iconFamily="fas" aria-hidden="true" />
                        AI Enhanced
                    </div>
                </div>
            )}
        </>
    )
}
